import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useWidgetConfig() {
  const [config, setConfig] = useState(null);
  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/widget/config`)
      .then(({ data }) => {
        if (active) setConfig(data);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);
  return config;
}
